<template>
  <div class="node_status">
    <span :class="[`type${style}`, 'node_status-value']">{{value}}</span>
    <span class="node_status-text">{{text}}</span>
    <i :class="[`status${style}`, 'node', 'node_status-status']"></i>
  </div>
</template>

<script>
export default {
  props: ['text', 'type', 'value'],
  computed: {
    style() {
      return this.type
    }
  }
}
</script>

